import axios from 'axios'
import { host } from '@/config/config'
import { Message, Loading } from 'element-ui'
import toRequestBody from './to-request-body'

axios.defaults.timeout = 10000
axios.defaults.baseURL = host

let loadingInstance

const handleRequest = config => {
  if (config.loading) {
    loadingInstance = Loading.service({
      text: '拼命加载中...'
    })
  }
  switch (config.method) {
    case 'get':
      config.headers['Content-Type'] = 'application/json'
      break
    case 'post':
      config.data = toRequestBody(config.data)
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      break
  }
  return config
}

const handleResponse = res => {
  loadingInstance && loadingInstance.close()
  const status = res.status
  if (status >= 200 && status < 300) {
    return res.data.data
    // const { code, message, data } = res.data
    // if (code === 0) {
    //   return data
    // } else {
    //   switch (code) {
    //     default:
    //       const error = {}
    //       error.message = message
    //       error.code = code
    //       error.data = data
    //       Message.error(`${code}错误：${message} `)
    //       return Promise.reject(error)
    //   }
    // }
  } else if (status >= 400 && status < 500) {
    Message.error(`客户端 ${status} 错误`)
  } else {
    Message.error(`服务器端 ${status} 错误`)
  }
}

const handleResponseError = err => {
  if (err.toString().includes('timeout')) {
    Message.error('请求超时，请刷新页面，重新加载页面')
  }
  return Promise.reject(err)
}

axios.interceptors.request.use(handleRequest)
axios.interceptors.response.use(handleResponse, handleResponseError)

export default axios



// WEBPACK FOOTER //
// ./src/utils/fetch.js